import { RootStateType } from 'redux/rootReducer';

export const isAuthenticatedSelector = (state: RootStateType) => state.global.auth.isAuthenticated;
export const tokenSelector = (state: RootStateType) => state.global.auth.token;
